import { Link } from 'react-router-dom';
import { articles } from '@/mocks/welfare';
import { categories } from '@/mocks/welfare';

export default function ArticleSection() {
  const latestArticles = articles.slice(0, 4);

  return (
    <section className="py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">最新福利攻略</h2>
            <p className="text-foreground-500 text-sm md:text-base">精选省钱技巧和福利指南，助你精明消费</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {latestArticles.map((article) => {
            const cat = categories.find((c) => c.id === article.category);
            return (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="bg-background-50 rounded-xl border border-background-200 overflow-hidden hover:border-primary-300 transition-all duration-300 group flex flex-col sm:flex-row"
              >
                <div className="relative w-full sm:w-56 h-44 sm:h-auto flex-shrink-0 overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    title={`${article.title} - 福利导航网`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    {cat && (
                      <span className="text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-md">{cat.name}</span>
                    )}
                    <span className="text-xs text-foreground-400">{article.publishDate}</span>
                  </div>
                  <h3 className="font-semibold text-foreground-900 text-sm leading-snug mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">{article.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">{article.summary}</p>
                  <div className="mt-auto flex items-center gap-3 flex-wrap">
                    {article.tags.slice(0, 3).map((tag) => (
                      <span key={tag} className="text-xs bg-background-100 text-foreground-500 px-2 py-0.5 rounded-md">{tag}</span>
                    ))}
                    <span className="text-xs text-primary-500 font-medium flex items-center gap-1 ml-auto">阅读全文 <i className="ri-arrow-right-s-line"></i></span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium"
          >
            查看全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}